import React from "react";
import PropTypes from "prop-types";
import { UiButton } from "ui-components";

/**
 * اکشن نمایش یک رکورد
 * @param {*Object} action آبجکت اکشن
 * @param {*Number} itemId شناسه رکورد
 */
const UiActionView = ({ action }) => {
    return (
        <UiButton
            type="icon"
            className={`icon ${action.icon}`}
            size="xxs"
            tooltip={action.tooltip}
            disabled={action.disabled}
        />
    );
};
UiActionView.propTypes = {
    action: PropTypes.object,
    itemId: PropTypes.number,
};

export default UiActionView;
